import { useEffect } from 'react';
const PIXEL_ID = '2186710912226229';

/**
 * Injects the official Meta Pixel base code and fires a PageView.
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const w = window as unknown as Record<string, any>;
    if (!w.fbq) {
      /* eslint-disable */
      !function (f: any, b: any, e: string, v: string) {
        let n: any, t: any, s: any;
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      /* eslint-enable */

      w.fbq('init', PIXEL_ID);
    }
    w.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-49" data-mp="18hl2ee2g1vbc">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-50" data-mp="13gx211sbs24g" />
    </noscript>;
}